// extracted by mini-css-extract-plugin
export default {"card":"fMP0XbtJ","header":"QPkmq8Lx","title":"I5510W3h","label":"Rh2_HaVY","name":"jdWVc999","buttons":"w0bevVI8","form":"k4CQSFkS","ant-form-item-label":"wKLTtUS_"};